import { isContactV3ApiBetaEnabled } from '@/service/parentContacts/isContactV3ApiBetaEnabled';
import { getAttendanceContactDeadline } from '@/service/parentContacts/getAttendanceContactDeadline';

/**
 * 受付締切時刻を v3 API で取得する。
 *
 * - ベータフラグ OFF 時は undefined を返す（呼び出し元は何もしない）
 * - ベータフラグ ON 時は GET を実行し DetailResponse を返す
 *
 * エラー時は呼び出し元（controller）に例外を伝播し、controller 側で
 * serverService.errorCallback チェーンに乗せる（既存 v2 フォームと同じUX）。
 */
export const displayAttendanceContactDeadline = async (facilityId: string) => {
  if (!(await isContactV3ApiBetaEnabled())) return undefined;
  return getAttendanceContactDeadline(facilityId);
};
